<template>
	<div class="view-container">
    <div style="width: 100%; overflow-x: auto">
      <div>
        <!-- <div class="tiles">
          <DashboardTile v-for="item in systemsFiltered" v-bind:key="item.id" :item="item" class="horizontal tiles-panel" />
        </div> -->
        <accordion>
          <accordion-item v-if="systemsDown.length != 0">
            <template slot="accordion-trigger">
              <h4>{{ $t('System Down') }} ({{systemsDown.length}})</h4>
            </template>
            <template slot="accordion-content">
              <div class="tiles">
                <DashboardTile v-for="item in systemsDown" v-bind:key="item.id" :item="item" class="horizontal tiles-panel" />
              </div>
            </template>
          </accordion-item>
          <accordion-item v-if="systemsErrors.length != 0">
            <template slot="accordion-trigger">
              <h4>{{ $t('Error')}} ({{systemsErrors.length}})</h4>
            </template>
            <template slot="accordion-content">
              <div class="tiles">
                <DashboardTile v-for="item in systemsErrors" v-bind:key="item.id" :item="item" class="horizontal tiles-panel" />
              </div>
            </template>
          </accordion-item>
          <accordion-item v-if="systemsWarnings.length != 0">
            <template slot="accordion-trigger">
              <h4>{{ $t('Warning')}} ({{systemsWarnings.length}})</h4>
            </template>
            <template slot="accordion-content">
              <div class="tiles">
                <DashboardTile v-for="item in systemsWarnings" v-bind:key="item.id" :item="item" class="horizontal tiles-panel" />
              </div>
            </template>
          </accordion-item>
          <accordion-item v-if="systemsWorkingFine.length != 0">
            <template slot="accordion-trigger">
              <h4>{{$t('Working Fine')}} ({{systemsWorkingFine.length}})</h4>
            </template>
            <template slot="accordion-content">
              <div class="tiles">
                <DashboardTile v-for="item in systemsWorkingFine" v-bind:key="item.id" :item="item" class="horizontal tiles-panel" />
              </div>
            </template>
          </accordion-item>
        </accordion>
      </div>
    </div>
  </div>
</template>

<script>
import { getSystemStatusList } from "@api";
import DashboardTile from '../components/Dashboard/DashboardTile.vue'
import SystemsFilter from '../components/Systems/SystemsFilter.vue'
import Accordion from '../components/Dashboard/Accordion.vue';
import AccordionItem from '../components/Dashboard/AccordionItem.vue'

export default {
  props: {},
  components: {
    DashboardTile,
    SystemsFilter,
    Accordion,
    AccordionItem
  },
  provide: {
  },
  data() {
    return {
      systems: [],
      interval: null,
    }
  },
  computed: {
    systemsDown() {
      return this.systems.filter(x => x.status == 3)
    },
    systemsErrors() {
      return this.systems.filter(x => x.status == 2)
    },
    systemsWarnings() {
      return this.systems.filter(x => x.status == 1)
    },
    systemsWorkingFine() {
      return this.systems.filter(x => x.status == 0)
    }
  },
  methods: {
    async getData() {
      this.$store.dispatch('set_loading', true)
      let result = await getSystemStatusList()
      this.systems = result;

      this.systems.forEach((s) => { //light yellow ffd6a3
        if (s.statusDescription == "System down") {
          s.status = 3
        } 

        var statusTranslation = s.statusDescription.split(',').map(x => this.$t(x.trim())).join(', ')
        s.statusDescription = statusTranslation
        
        s.statusColor = ['#3CD6B1', '#FFBD6D', '#FF6666', '#3c3c3c'][s.status];
        s.backgroundColor = ['rgba(230, 255, 244, 0.5)', 'rgba(252, 237, 217, 0.5)', 'rgba(255, 224, 224, 0.5)', '#b1b1b17f'][s.status];

        var t1 = new Date(s.lastUpdate)
        var result = t1.toAgoString()
        
        s.lastUpdateFrom = result
      })

      this.systems = this.systems.sort(this.doubleSorting)
      this.$store.dispatch('set_loading', false)
    },
    doubleSorting(a, b) {
        if(a.status != b.status) {
            return (b.status - a.status);
        }
        else {
            return (a.name.localeCompare(b.name, undefined, {
              numeric: true,
              sensitivity: 'base'
            }));
        }      
    },
    intervalMethod() {
      this.getData()
    }
  },
  mounted: async function () {
    await this.getData();
    this.interval = setInterval(() => this.intervalMethod(), 15000);
  },
  destroyed() {
    clearInterval(this.interval);
  },
}
</script>

<style scoped>
.tiles {
  display: grid;
  grid-template-columns: repeat(auto-fit, 280px);
  grid-row-gap: 5px;
  grid-column-gap: 20px;
  width: 100%;
  place-content: left;
  margin-top: 5px;
  align-self: start;
}

</style>

<style> 
.accordion__content > ul {
  padding: 0px !important;
}
</style>


// WEBPACK FOOTER //
// src/views/Dashboard.vue